export const ProductFormulations = {
    ORAL_LIQUID: 'Oral Liquid',
    HERB_DRIED: 'Herb, Dried',
    CAPSULE: 'Capsule',
    PASTILLE: 'Pastille',
    DEVICE: 'Device',
    INHALATION: 'Inhalation',
    TOPICAL: 'Topical',
    SPRAY: 'Spray',
    WAFER: 'Wafer',
    TABLET_CHEWABLE: 'Tablet, Chewable',
    CONCENTRATED_EXTRACT: 'Concentrated Extract',
    INHALANT_PRESSURIZED: 'Inhalant (pressure)',
    POWDER: 'Powder',
    TABLET_EFFERVESCENT: 'Tablet, Effervescent',
    PESSARY: 'Pessary',
};
const PRODUCT_FORMULATION_NAMES = new Set(Object.values(ProductFormulations));
export const isProductFormulation = (formulation) => PRODUCT_FORMULATION_NAMES.has(formulation);
export const ProductFormulationFilters = {
    ...ProductFormulations,
    ALL: 'all',
};
export const ProductStrains = {
    SATIVA: 'Sativa',
    INDICA: 'Indica',
    HYBRID: 'Hybrid',
    /** @deprecated Superseded by {@link ProductStrains.HYBRID} */
    BALANCED: 'Balanced',
};
export const ProductStrainKeys = {
    SATIVA: 'sativa',
    INDICA: 'indica',
    HYBRID: 'hybrid',
};
export const ProductSpectrums = {
    BROAD: 'Broad',
    FULL: 'Full',
};
export const BRANDS = {
    MONTU: 1,
    ALTERNALEAF: 2,
    UMEDS: 3,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvZHVjdC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy90eXBlcy9wcm9kdWN0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQTZKQSxNQUFNLENBQUMsTUFBTSxtQkFBbUIsR0FBRztJQUNqQyxXQUFXLEVBQUUsYUFBYTtJQUMxQixVQUFVLEVBQUUsYUFBYTtJQUN6QixPQUFPLEVBQUUsU0FBUztJQUNsQixRQUFRLEVBQUUsVUFBVTtJQUNwQixNQUFNLEVBQUUsUUFBUTtJQUNoQixVQUFVLEVBQUUsWUFBWTtJQUN4QixPQUFPLEVBQUUsU0FBUztJQUNsQixLQUFLLEVBQUUsT0FBTztJQUNkLEtBQUssRUFBRSxPQUFPO0lBQ2QsZUFBZSxFQUFFLGtCQUFrQjtJQUNuQyxvQkFBb0IsRUFBRSxzQkFBc0I7SUFDNUMsb0JBQW9CLEVBQUUscUJBQXFCO0lBQzNDLE1BQU0sRUFBRSxRQUFRO0lBQ2hCLG1CQUFtQixFQUFFLHNCQUFzQjtJQUMzQyxPQUFPLEVBQUUsU0FBUztDQUNWLENBQUM7QUFJWCxNQUFNLHlCQUF5QixHQUF3QixJQUFJLEdBQUcsQ0FBQyxNQUFNLENBQUMsTUFBTSxDQUFDLG1CQUFtQixDQUFDLENBQUMsQ0FBQztBQUNuRyxNQUFNLENBQUMsTUFBTSxvQkFBb0IsR0FBRyxDQUFDLFdBQW1CLEVBQXFDLEVBQUUsQ0FDN0YseUJBQXlCLENBQUMsR0FBRyxDQUFDLFdBQVcsQ0FBQyxDQUFDO0FBRTdDLE1BQU0sQ0FBQyxNQUFNLHlCQUF5QixHQUFHO0lBQ3ZDLEdBQUcsbUJBQW1CO0lBQ3RCLEdBQUcsRUFBRSxLQUFLO0NBQ0YsQ0FBQztBQUlYLE1BQU0sQ0FBQyxNQUFNLGNBQWMsR0FBRztJQUM1QixNQUFNLEVBQUUsUUFBUTtJQUNoQixNQUFNLEVBQUUsUUFBUTtJQUNoQixNQUFNLEVBQUUsUUFBUTtJQUNoQiw4REFBOEQ7SUFDOUQsUUFBUSxFQUFFLFVBQVU7Q0FDWixDQUFDO0FBSVgsTUFBTSxDQUFDLE1BQU0saUJBQWlCLEdBQUc7SUFDL0IsTUFBTSxFQUFFLFFBQVE7SUFDaEIsTUFBTSxFQUFFLFFBQVE7SUFDaEIsTUFBTSxFQUFFLFFBQVE7Q0FDUixDQUFDO0FBSVgsTUFBTSxDQUFDLE1BQU0sZ0JBQWdCLEdBQUc7SUFDOUIsS0FBSyxFQUFFLE9BQU87SUFDZCxJQUFJLEVBQUUsTUFBTTtDQUNiLENBQUM7QUFFRixNQUFNLENBQUMsTUFBTSxNQUFNLEdBQUc7SUFDcEIsS0FBSyxFQUFFLENBQUM7SUFDUixXQUFXLEVBQUUsQ0FBQztJQUNkLEtBQUssRUFBRSxDQUFDO0NBQ1QsQ0FBQyJ9